import { DeseretBook } from '@deseretbook/dbcom-sdk'

export default new DeseretBook({
  host: window.location.origin,
  headers: {
    'X-Spree-Token': Cookies.get('X-SPREE-TOKEN'),
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  endpoints: {
    checkout: {
      endpoints: {
        update: {
          settings: {
            requestResolver: {
              formatBody() {
                /**
                 * We hijack the formatting of the request body to move the `recaptchaToken` out
                 * into the key the recaptcha gem expects it in. We do that here because dbcom-sdk
                 * formats everything snake case, but the gem likes it in kebab cases, so this is
                 * the least inttrusive place to override it.
                 */
                return ({ order, recaptcha_token }) => {
                  return JSON.stringify({
                    order,
                    ...(!!recaptcha_token && {
                      'g-recaptcha-response-data': recaptcha_token,
                    }),
                  })
                }
              },
            },
          },
        },
      },
    },
    user: {
      endpoints: {
        creditCard: {
          endpoints: {
            create: {
              settings: {
                requestResolver: {
                  /**
                   * We hijack the formatting of the request body to move the `recaptchaToken` out
                   * into the key the recaptcha gem expects it in. We do that here because dbcom-sdk
                   * basically doesn't allow us and this is the easiest place to handle this.
                   */
                  formatBody() {
                    return ({
                      credit_card: { recaptcha_token, ...credit_card },
                    }) => {
                      return JSON.stringify({
                        credit_card,
                        ...(!!recaptcha_token && {
                          'g-recaptcha-response-data': recaptcha_token,
                        }),
                      })
                    }
                  },
                },
              },
            },
          },
        },
      },
    },
  },
})
